// extracted by mini-css-extract-plugin
export default {"wrap":"AdminLayout_wrap__jBTob","side":"AdminLayout_side__wYYb-","item":"AdminLayout_item__Cq3v1","active":"AdminLayout_active__eqoVZ","content":"AdminLayout_content__UVDus"};